<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title">Hello : <span class="orange strong">{{store.$state.user.name}}</span></h1>
                </div>
            </div>
        </div>
    </div>

    <div class="content-area user-profiel" style="background-color: #FCFCFC;">&nbsp;
        <div class="container">
            <div class="row">
                <div class="col-sm-10 col-sm-offset-1 profiel-container">

                    <div class="profiel-header">
                        <h3>
                            <b>YOUR</b> PROFILE <br>
                        </h3>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <ul class="list-group">
                                <li class="list-group-item"><strong>Name:</strong> {{store.$state.user.name}}</li>
                                <li class="list-group-item"><strong>Email:</strong> {{store.$state.user.email}}</li>
                                <li class="list-group-item"><strong>Phone:</strong> {{store.$state.user.phone}}</li>
                                <li class="list-group-item"><strong>Date Joined:</strong> {{getCreatedAt()}}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">

                        </div>
                    </div>

                </div>
            </div><!-- end row -->

        </div>
    </div>
</template>

<script>
import {reactive, ref} from "vue";
import moment from "moment";
import {useAuthStore} from "../../../store/auth";

export default {
    name: "EditProfile",
    setup() {
        const store = useAuthStore();

        const getCreatedAt = () => {
            return moment(store.user.created_at).format('DD MMM YYYY');
        }

        return {
            store,
            getCreatedAt
        }
    }
}
</script>
<style scoped>
  .profiel-container {
      padding: 10px 5px;
  }
</style>
